import React from 'react';
import GenericFormTab from './GenericFormTab';
import { invoiceFields } from '../formFields/asnTabsFields';

export default function InvoiceTab({ formData, onChange, formSubmissionAttempted }) {
  return (
    <GenericFormTab 
      fields={invoiceFields} 
      formData={formData} 
      onChange={onChange}
      formSubmissionAttempted={formSubmissionAttempted}
    />
  );
}
